import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box,
    Divider,
    Heading,
    HStack,
    Image,
    Text,
    VStack
} from "@chakra-ui/react";
import {StyledButton} from "../../components";
import {earlyAccessPageHighlights, faq_questions} from "../../helpers/data-jsons";
import {ReferalProgram} from "./parts/ReferalProgram";
import {SubscriptionsCarousel} from "./parts/SubscriptionsCarousel";
import {ReactComponent as PreviewIcon} from "../../assets/icons/users_preview_icon.svg";
import {ReactComponent as AfterIcon} from "../../assets/icons/afterIcon.svg";
import {UsersCommentsCarousel} from "./parts/UsersCommentsCarousel";

const EarlyAccess = () => {


    return (
        <Box
            position={'relative'}>
            <Image
                top={'0'}
                w={'full'}
                h={'full'}
                maxH={'1138px'}
                left={'0'}
                zIndex={'1'}
                opacity={'0.5'}
                position={'absolute'}
                src={'/images/early_access_header_bg.png'}
            />
            <VStack
                zIndex={"99"}
                m={'auto'}
                overflow={'hidden'}
                gap={'139px'}
                p={'112px 16px 0 16px'}
            >
                <Box
                    maxW={'xl'}
                    textAlign={'center'}
                    fontWeight={'500'}
                    color={'neutral.100'}
                    as={'section'}>
                    <Box
                        m={'auto'}
                        maxW={'1114px'}>
                        <Heading fontSize={{base: 'heading.3xl', lg: 'display.xl'}}>Buy Low, Sell High—Seamlessly Across
                            Leading Exchanges</Heading>
                        <Text mt={'24px'} color={'neutral.500'}>Early Access users gain exclusive tools for smarter
                            trading decisions.</Text>
                        <StyledButton
                            mt={'48px'}
                            h={'48px'}
                            w={'167px'}>
                            Get Access Now
                        </StyledButton>
                    </Box>
                    <Image
                        mt={'136px'}
                        alt={'Coins Info'}
                        src={'/images/coins_info.png'}
                    />
                </Box>
                <VStack
                    gap={'64px'}>
                    {
                        earlyAccessPageHighlights.map((item, index) => (
                            <Box position={'relative'}>
                                <HStack
                                    overflow={'hidden'}
                                    flexDirection={{
                                        base: 'column-reverse',
                                        md: (index + 1) % 2 === 0 ? 'row-reverse' : 'row'
                                    }}
                                    justifyContent={'space-between'}
                                    key={index}>
                                    <Box
                                        position={'absolute'}
                                        w={'1142px'}
                                        left={(index + 1) % 2 === 0 ? undefined : '-560px'}
                                        right={(index + 1) % 2 === 0 ? '-560px' : undefined}
                                        blur={'150px'}
                                        h={'513px'}
                                        top={'0'}
                                        bg={'linear-gradient(266deg, rgba(141, 49, 245, 0) 0%, rgba(141, 49, 245, 0.5) 100%, rgba(255, 255, 255, 0.5) 100%)'}
                                        opacity={'0.15'}
                                        filter={'blur(55px)'}
                                        borderRadius={'996px'}
                                    />
                                    <Box w={'full'}
                                         maxW={'xl'}
                                         display={'flex'}
                                         flexDirection={(index + 1) % 2 === 0 ? 'row-reverse' : 'row'}
                                         justifyContent={'space-between'}
                                         alignItems={'center'}
                                    >
                                        <Box>{item.icon}</Box>
                                        <VStack
                                            maxW={'50%'}
                                            justifyContent={'space-between'}
                                            gap={'32px'}>
                                            <Heading color={'neutral.100'}>{item.title}</Heading>
                                            <Text color={'neutral.500'}>{item.description}</Text>
                                        </VStack>
                                    </Box>

                                </HStack>
                            </Box>
                        ))
                    }
                </VStack>
                <Box w={'full'}
                     maxW={'xl'}>
                    <ReferalProgram/>
                </Box>
                <Box
                    maxW={'xl'}
                    mb={'50px'}
                    textAlign={'center'}
                    display={{base: 'none', md: 'block', lg: 'block'}}
                    color={'neutral.100'}>
                    <Heading fontSize={'display.md'}>Limited-Time Offer for Early Access</Heading>
                    <HStack justifyContent={'center'}>
                        <VStack>
                            <SubscriptionsCarousel/>
                        </VStack>
                    </HStack>
                </Box>
                <Box
                    mb={'60px'}
                    maxW={'xl'}
                    overflow={'hidden'}
                    w={'full'}
                    position={'relative'}
                    color={'neutral.100'}
                    textAlign={'center'}>
                    <HStack justifyContent={'center'}>
                        <Box
                            left={'0'}
                            top={'0'}
                            position={'absolute'}>
                            <PreviewIcon/>
                        </Box>
                        <VStack>
                            {/*<HStack>*/}
                            {/*    <Box*/}
                            {/*        w={'10px'}*/}
                            {/*        h={'10px'}*/}
                            {/*        bg={'purple.400'}*/}
                            {/*        borderRadius={'50%'}*/}
                            {/*        boxShadow={'0px 0px 8px 0px #5834A8'}*/}
                            {/*    />*/}
                            {/*    <Text fontSize={'body.lg'}>User Reviews</Text>*/}
                            {/*</HStack>*/}
                            <Heading fontSize={'display.md'}>What our users say</Heading>
                            <UsersCommentsCarousel/>
                        </VStack>
                        <Box
                            right={'0'}
                            bottom={'0'}
                            position={'absolute'}>
                            <AfterIcon/>
                        </Box>
                    </HStack>
                </Box>
                <Box
                    maxW={'808px'}
                    textAlign={'center'}
                    color={'neutral.100'}>
                    <VStack gap={'12px'}>
                        {/*<HStack>*/}
                        {/*    <Box*/}
                        {/*        w={'10px'}*/}
                        {/*        h={'10px'}*/}
                        {/*        bg={'purple.400'}*/}
                        {/*        borderRadius={'50%'}*/}
                        {/*        boxShadow={'0px 0px 8px 0px #5834A8'}*/}
                        {/*    />*/}
                        {/*    <Text fontSize={'body.lg'}>FAQ</Text>*/}
                        {/*</HStack>*/}
                        <Heading fontSize={'display.md'}>Frequently Asked Question</Heading>
                        <Text fontSize={'body.xl'}>
                            Explore the most common questions and detailed answers about our
                            platform, services, and security to help guide your journey in the crypto world.
                        </Text>
                        <Accordion
                            allowMultiple
                            w={'full'}
                            color={'neutral.500'}
                            mt={'48px'}>
                            {
                                faq_questions.map((item, index) => (
                                    <AccordionItem
                                        key={index}
                                        mb={'16px'}
                                        borderRadius={'8px'}
                                        border={'1px solid'}
                                        borderColor={'neutral.900'}>
                                        {({isExpanded}) => (
                                            <>
                                                <AccordionButton
                                                    h={'56px'}
                                                    display={'flex'}
                                                    alignItems={'center'}>
                                                    <Box as='span' color={isExpanded ? 'neutral.100' : 'neutral.500'}
                                                         flex='1' textAlign='left'>
                                                        {item.title}
                                                    </Box>
                                                    <Box
                                                        w={'24px'}
                                                        h={'24px'}
                                                        border={'solid 2px #fff'}
                                                        borderRadius={'50%'}
                                                        display={'flex'}
                                                        alignItems={'center'}
                                                        justifyContent={'center'}
                                                    >
                                                        <AccordionIcon/>
                                                    </Box>
                                                </AccordionButton>
                                                {isExpanded && <Divider w="95%" mx="auto" borderColor="neutral.800"/>}
                                                <AccordionPanel pb={4}
                                                                fontSize={'body.sm'}>{item.description}</AccordionPanel>
                                            </>
                                        )}
                                    </AccordionItem>
                                ))
                            }
                        </Accordion>
                    </VStack>
                </Box>
            </VStack>
        </Box>
    )
}

export default EarlyAccess